import React from "react";
import { useMediaQuery, useTheme } from "@material-ui/core";
import { MobilePlayerBar } from "./mobile-player-bar";
import { DesktopPlayer } from "./desktop-player";
export var Player = function () {
    var theme = useTheme();
    var showMobilePlayer = useMediaQuery(theme.breakpoints.down("xs"));
    return showMobilePlayer ? React.createElement(MobilePlayerBar, null) : React.createElement(DesktopPlayer, null);
};
